import { AuthService } from '@/services/auth.service'
import { UsersService } from '@/services/users.service'

export default {
  getCurrent ({ commit }, payload) {
    console.log('user/getCurrent, вызвано из:', payload);

    //return AuthService.getCurrentSession()
    return UsersService.getCurrent()    
      .then(user => {
        commit('SET_CURRENT_USER', user.data);                
        commit('SET_OWNER_PERSON', user.data.person);
      })
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  },

  getCurrentSession ({ commit }, payload) {
    console.log('user/getCurrentSession, вызвано из:', payload);

    return AuthService.getCurrentSession()    
      .then(user => commit('SET_CURRENT_SESSION', user.data))
      .catch(error => commit('toast/NEW', { type: 'error', message: error.message }, { root: true }))
  }
}
